import { lighten } from "@material-ui/core/styles/colorManipulator";
export const styles = (theme) => ({
  rootPortrait: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(4),
    color: "#292f48",
    width: theme.spacing(74),
    //   height: theme.spacing(105),
  },
  rootLandscape: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(4),
    color: "#292f48",
    width: "842px",
    minHeight: "595px",
    //   width: theme.spacing(105),
    //   minHeight: theme.spacing(74)
  },
  rowReportEmployee: {
    paddingTop: "2px !important",
    paddingBottom: "2px !important",
  },
  textRowReport: {
    fontSize: "10px",
  },
  breakLineReport: {
    backgroundColor: "rgba(41, 47, 72, 0.5)",
    width: "100%",
    height: "1px",
    borderWidth: 0,
    // marginTop: '12px',
    marginTop: "8px",
    // marginBottom: '12px',
    marginBottom: "8px",
  },
  title: {
    color: theme.palette.secondary.main,
    fontSize: "24px",
    fontWeight: "bold",
  },
  subTitle: {
    // fontSize: '12px',
    fontWeight: "bold",
    paddingLeft: "1rem",
  },
  button: {
    backgroundColor: "#292f48",
    // paddingLeft: '40px',
    // paddingRight: '40px',
    // paddingTop: '12px',
    // paddingBottom: '12px',
  },
  wrapButton: {
    display: "flex",
    justifyContent: "flex-end",
  },
  paperWidthSm: {
    width: "80%",
    height: "100%",
    maxWidth: "unset",
    position: "relative",
  },
  titleDialog: {
    fontWeight: 500,
    fontSize: "24px",
    textAlign: "left",
  },
  headDialog: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: "5.33rem",
    paddingBottom: "2.65rem",
    boxShadow:
      "0px 2px rgba(0,0,0,0.2),0px 4px rgba(0,0,0,0.14),0px 1px rgba(0,0,0,0.12)",
  },
  content: {
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
  header: {
    paddingLeft: "0px !important",
    paddingRight: "0px !important",
  },
  wrapBorder: {
    borderBottom: "2px solid rgba(41, 47, 72, 0.15)",
    marginRight: theme.spacing(1),
  },
  footer: {
    marginLeft: "-12px",
  },
  // General
  fs12: {
    fontSize: "12px",
  },
  fs14: {
    fontSize: "14px",
  },
  textLeft: {
    textAlign: "left",
  },
  textRight: {
    textAlign: "right",
  },
  textCenter: {
    textAlign: "center",
  },
  textBold: {
    fontWeight: "bold",
  },
  p0: {
    padding: "0px !important",
  },
  pt0: {
    paddingTop: "0px !important",
  },
  pb0: {
    paddingBottom: "0px !important",
  },
  p1: {
    padding: theme.spacing(1),
  },
  pl2: {
    paddingLeft: theme.spacing(2),
  },
  pr2: {
    paddingRight: theme.spacing(2),
  },
  mt1: {
    marginTop: theme.spacing(1),
  },
  ml1: {
    marginLeft: theme.spacing(1),
  },
  mr1: {
    marginRight: theme.spacing(1),
  },
  mt2: {
    marginTop: theme.spacing(2),
  },
  mt3: {
    marginTop: theme.spacing(3),
  },
  mt4: {
    marginTop: theme.spacing(4),
  },
  mt5: {
    marginTop: theme.spacing(5),
  },
  ml6: {
    marginLeft: theme.spacing(6),
  },
  backgroundPrimary: {
    backgroundColor: "rgba(255, 81, 63, 0.1)",
  },
  backgroundGray: {
    backgroundColor: "rgba(41, 47, 72, 0.1)",
  },
  containerCountAmount: {
    borderBottom: "1px solid rgba(41, 47, 72, 0.5)",
    marginBottom: "14px",
  },
});
